// extracted by mini-css-extract-plugin
module.exports = {"top":"wR","bottom":"xR","new":"yR","styleRoom":"zR","isTrusted":"AR","productLink":"BR","details":"CR","productName":"DR","brandName":"ER","colorName":"FR","storeWrapper":"GR"};